<template>
  <div>
    <FeedSidebarItem :label="t('ui.filter')">
      <FiltersSelector />
    </FeedSidebarItem>

    <FeedSidebarItem
      v-show="showSavedSearches"
      data-testid="savedSearchesSidebar"
      :label="t('savedSearches.headline')">
      <SavedSearchesList @saved-searches-loaded="handleSavedSearchesLoaded" />
    </FeedSidebarItem>
  </div>
</template>

<script setup lang="ts">
import { type MaybeRefOrGetter, ref, toValue } from "vue";
import { useI18n } from "vue-i18n";

import FiltersSelector from "../FiltersSelector/FiltersSelector.vue";
import SavedSearchesList from "../SavedSearches/SavedSearchesList.vue";

import FeedSidebarItem from "./FeedSidebarItem.vue";

const { t } = useI18n();

const showSavedSearches = ref(true);
function handleSavedSearchesLoaded(count: MaybeRefOrGetter<number>) {
  window.Appcues?.track?.("Load Saved Search", {
    location: "Feed Sidebar",
  });

  showSavedSearches.value = toValue(count) !== 0;
}
</script>
